import { CircleLayer } from '@trimblemaps/trimblemaps-js';
import { FeatureTypes, MapLayers, MapSources } from '../enums';
import { isVisibleUtil } from '../mapUtils';

/**
 * Creates a layer to display circles on the map for each Point and 'featureType' of 'areaCenter' in the given map source.
 * Adds the balance areas center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addBalanceAreasCenterLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    const visibility = isVisibleUtil(isVisible);

    const layer: CircleLayer = {
        id: MapLayers.balanceAreasCenterLayer,
        type: 'circle',
        source: mapSource,
        layout: {
            visibility,
        },
        paint: {
            'circle-color': ['get', 'color'],
            'circle-opacity': 1.0,
            'circle-radius': 6,
            'circle-stroke-width': 2,
            'circle-stroke-color': ['get', 'strokeColor'],
        },
        filter: ['all',
            ['==', '$type', 'Point'],
            ['==', 'featureType', FeatureTypes.AreaCenter],
        ],
    };

    if (map.getLayer(MapLayers.balanceAreasCenterLayer) === undefined) {
        map.addLayer(layer);
    }
};
